import { Node, NodeProps } from 'reactflow';
import { AiSmartReplyPlanItem } from '../../../../../sic-lib/api/ai/types/Ai';

export type SmartAiPlanActionNode = Node<
    {
        planItem: AiSmartReplyPlanItem | undefined;
    },
    'planItem'
>;

export function PlanItemNode(props: NodeProps<SmartAiPlanActionNode>) {
    return <div></div>;
}
